import { ODSAvatar, ODSButton } from '@telekom-ods/react-ui-kit';
import type Keycloak from 'keycloak-js';
import { type JSX } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import { handleAuthNavigation } from '../../helpers/handleAuthNavigation';
import useAppContext from '../../hooks/useAppContext';
import Tooltip from '../Tooltip';

import NavItem from './NavItem';

interface BottomCollapsedItemProps {
  authenticated?: boolean;
  keycloak: Keycloak;
}

const BottomCollapsedItem = ({
  authenticated,
  keycloak,
}: BottomCollapsedItemProps): JSX.Element => {
  const intl = useIntl();
  const { toggleTheme, theme, cookiesAccepted } = useAppContext();
  const navigate = useNavigate();

  return (
    <>
      {authenticated && (
        <>
          <NavItem
            {...{
              to: '/whats-new',
              theme,
              label: "What's New",
              icon: 'notification-type-standard',
            }}
          />
          <NavItem
            {...{
              to: `/docs/${import.meta.env.VITE_CONFLUENCE_HOMEPAGE}`,
              theme,
              label: 'Portal Documentation',
              icon: 'link-type-standard',
            }}
          />
        </>
      )}
      <NavItem
        {...{
          to: '/support-and-feedback',
          theme,
          label: 'Help and Feedback',
          icon: 'help-type-standard-size-small',
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <ODSAvatar
          icon='light-dark-mode-type-bold'
          name='theme-toggle'
          showBackground
          size='large'
          variant='icon'
          onClick={toggleTheme}
        />
        <Tooltip
          key='sidebar-login-logout'
          title={!cookiesAccepted ? intl.formatMessage({ id: 'privacyPolicyConfirmation' }) : ''}
        >
          <ODSButton
            label={
              authenticated
                ? intl.formatMessage({ id: 'logout' })
                : intl.formatMessage({ id: 'login' })
            }
            size='small'
            variant='outline'
            disabled={!cookiesAccepted}
            onClick={() => {
              if (authenticated) {
                keycloak.logout({
                  redirectUri: window.location.origin,
                });
              } else {
                handleAuthNavigation({
                  authenticated,
                  cookiesAccepted,
                  navigate,
                  keycloak,
                });
              }
            }}
          />
        </Tooltip>
      </div>
    </>
  );
};

export default BottomCollapsedItem;
